import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/profile-components/Navbar";
import Topbar from "../../components/profile-components/Topbar";
import "../SalesPages.css";
import "../Settings.css";
import { authFetch } from "../../utils/authFetch";

export default function SystemEmails() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = async () => {
    try {
      setLoading(true);

      const res = await authFetch("/api/system-emails");

      if (res.status === 403) {
        alert("You do not have permission to access System Emails.");
        navigate("/dashboard");
        return;
      }

      if (!res.ok) throw new Error("Failed to load system emails");

      const data = await res.json();
      setEmails(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error loading system emails:", err.message);
      setEmails([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Topbar />

      <div className="main-content sales-page settings-page-modern">
        <div className="sales-hero sales-profile-hero">
          <div>
            <p className="sales-eyebrow">Settings</p>
            <h1 className="sales-title">System Emails</h1>
            <p className="sales-subtitle">
              Manage CRM-triggered email templates used for onboarding, verification,
              password reset, and other system events.
            </p>
          </div>

          <div className="sales-header-actions">
            <Link
              className="sales-secondary-btn"
              to="/settings?tab=Data%20%26%20Customization"
              style={{ textDecoration: "none" }}
            >
              ← Back to Data & Customization
            </Link>

            <button
              className="sales-primary-btn"
              onClick={() => navigate("/settings/system-emails/new")}
            >
              + Add System Email
            </button>
          </div>
        </div>

        <div className="sales-table-card">
          <div className="sales-table-header">
            <div>
              <h2>System Email Library</h2>
              <p>{emails.length} system email{emails.length === 1 ? "" : "s"}</p>
            </div>
          </div>

          <div className="sales-table-wrap">
            <table className="sales-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Subject</th>
                  <th style={{ width: "110px" }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="sales-empty-cell">
                      Loading system emails...
                    </td>
                  </tr>
                ) : emails.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="sales-empty-cell">
                      No system emails found.
                    </td>
                  </tr>
                ) : (
                  emails.map((email) => (
                    <tr key={email.id}>
                      <td>
                        <div className="sales-primary-cell">
                          <div className="sales-name">{email.name}</div>
                        </div>
                      </td>

                      <td>
                        {email.subject ? (
                          <span>{email.subject}</span>
                        ) : (
                          <span className="sales-secondary">No subject</span>
                        )}
                      </td>

                      <td>
                        <button
                          className="sales-secondary-btn"
                          onClick={() => navigate(`/settings/system-emails/${email.id}`)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}